/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_EyebrowInputs */

const en_home_hero_eyebrow = /** @type {(inputs: Home_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`privacy-first json toolkit`)
};

const ko_home_hero_eyebrow = /** @type {(inputs: Home_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프라이버시 우선 json 도구`)
};

const ja_home_hero_eyebrow = /** @type {(inputs: Home_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシー重視の json ツール`)
};

/**
* | output |
* | --- |
* | "privacy-first json toolkit" |
*
* @param {Home_Hero_EyebrowInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const home_hero_eyebrow = /** @type {((inputs?: Home_Hero_EyebrowInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_EyebrowInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_eyebrow(inputs)
	if (locale === "ko") return ko_home_hero_eyebrow(inputs)
	return ja_home_hero_eyebrow(inputs)
});